import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-hierarchy-view',
  templateUrl: './hierarchy-view.component.html',
  styleUrls: ['./hierarchy-view.component.scss'],
})
export class HierarchyViewComponent implements OnInit {
  search: string;
  @Input() header: string;
  @Input() hierarchy: any;
  @Input() width: number = 50;
  @Input() top: number = null;

  @Output() closePopup = new EventEmitter();
  @Input() selected: string[] = [];
  @Output() selectedChange = new EventEmitter<string[]>();

  constructor() { }

  ngOnInit() { }

  close() {
    this.selectedChange.emit(this.selected);
    this.closePopup.emit();
  }

  getTop() {
    if (this.top) {
      return this.top + "%";
    } else {
      return "";
    }
  }

  clickClearAll() {
    this.selected = [];
    this.uncheckHierarchy(this.hierarchy);
  }
  uncheckHierarchy(hierarchy) {
    for (let child of hierarchy) {
      child.selected = false;
      if (child.subCategory && child.subCategory.length > 0) {
        this.uncheckHierarchy(child.subCategory);
      }
    }
  }
}
